var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.classes(),attrs:{"href":"https://www.tuev-saar.de/zertifikat/sc45270/","rel":"noopener","target":"_blank"}},[_c('img',{attrs:{"src":"https://mailing-assets.pflege.de/tuev/tuev_big.png","width":"194","height":"102"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }